import { useQuery } from '@tanstack/react-query';
import { List, ListItem, Paper, Stack, Typography } from '@mui/material';
import { getFollowUpDashboard } from '../../api/dashboard';
import { useBranchFilter } from '../../context/branchContext';
import { EmptyState } from '../../components/EmptyState';

export const FollowUpOverviewCard = () => {
  const { selectedBranchId } = useBranchFilter();
  const dashboardQuery = useQuery({
    queryKey: ['follow-up-dashboard', selectedBranchId],
    queryFn: () => getFollowUpDashboard(selectedBranchId),
  });
  const data = dashboardQuery.data;

  return (
    <Paper sx={{ p: 2, height: '100%' }}>
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        Follow-up overview
      </Typography>
      <Stack direction="row" spacing={4} sx={{ mb: 1.5 }}>
        <div>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            {data?.totalFollowUps ?? '—'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Total follow-ups
          </Typography>
        </div>
        <div>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            {data?.averageResponseTimeHours ?? '—'}h
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Avg. response time
          </Typography>
        </div>
      </Stack>
      {data && data.byCounselor.length === 0 ? (
        <EmptyState loading={dashboardQuery.isLoading} message="No follow-ups logged yet" />
      ) : (
        <List dense disablePadding>
          {data?.byCounselor.slice(0, 6).map((entry) => (
            <ListItem key={entry.counselorId} disableGutters sx={{ py: 0.5 }}>
              <Stack direction="row" justifyContent="space-between" sx={{ width: '100%' }}>
                <Typography variant="body2" noWrap>
                  {entry.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {entry.count}
                </Typography>
              </Stack>
            </ListItem>
          ))}
        </List>
      )}
    </Paper>
  );
};
